const PAGINATION = {
  pageIndex: 0,
  pageSize: 100,
  minDataCount: 50,
};

export default PAGINATION;
